import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { SlideoverReducerState, SlideoverReducerStateIdKeys } from "./reducer_interface";

const CustomerProfileSlideovers = {
  CUSTOMER_PROFILE_MEMBERSHIP_DETAILS: false,
  CUSTOMER_PROFILE_DISCOUNT_DETAILS: false,
  CALENDAR_VIEW_FILTERS: false,
  BOOKING_DETAILS_VIEW: false,
};

// Define the initial state using that type
const intialRootState: SlideoverReducerState = {
  ...CustomerProfileSlideovers,
};

export const rootStateSlice = createSlice({
  name: "slideovers",
  initialState: intialRootState,
  reducers: {
    setSlideoverState: (state, action: PayloadAction<{ key: SlideoverReducerStateIdKeys; status: boolean }>) => {
      state[action.payload.key as SlideoverReducerStateIdKeys] = action.payload.status;
    },
  },
});

export const { setSlideoverState } = rootStateSlice.actions;

export default rootStateSlice.reducer;
